const FETCH_PAYROLLS = 'fetch_payrolls';
const FETCH_PAYROLLS_ENTITIES = 'fetch_payrolls_entities';
const FETCH_PAYROLLS_CSV = 'fetch_payrolls_csv';
const FETCH_PAYROLL = 'fetch_payroll';
const FETCH_PAYROLLS_PROVIDERS = 'fetch_payroll_providers';
const FETCH_PAYROLLS_IN_FILE = 'fetch_payrolls_in_file';
const DELETE_PAYROLL = 'delete_payroll';
const PERSIST_PAYROLL = 'persist_payroll';
const UPDATE_PAYROLL = 'update_payroll';

export default {
    FETCH_PAYROLLS,
    FETCH_PAYROLLS_ENTITIES,
    FETCH_PAYROLLS_PROVIDERS,
    FETCH_PAYROLLS_CSV,
    FETCH_PAYROLLS_IN_FILE,
    FETCH_PAYROLL,
    DELETE_PAYROLL,
    PERSIST_PAYROLL,
    UPDATE_PAYROLL,
};
